export const ROLES = Object.freeze({
  SALUD: 'salud',
  ADMINISTRATIVO: 'administrativo',
  MEDICO: 'medico',
})

export const TIPOS_FACTURACION_PERMITIDOS = Object.freeze({
  CONTADO: 'contado',
  CREDITO: 'credito',
})

export const MODULOS = Object.freeze({
  HOME: 'home',
  DESCARGA_MASIVA: 'descargaMasiva',
  PAGAR_OTROS_SERVICIOS: 'pagarOtrosServicios',
  CREAR_ORDEN: 'crearOrden',
  ORDENES_MASIVAS: 'ordenesMasivas',
  GESTION_ORDENES: 'gestionOrdenes',
  GESTION_ATENCIONES: 'gestionAtenciones',
  REPORTE_DETALLE_MOVIMIENTO: 'reporteDetalleMovimiento',
  VER_DETALLE_MOVIMIENTO: 'verDetalleMovimiento',
  RECARGAR_CUENTA: 'recargarCuenta',
  VER_PACIENTES: 'verPacientes',
})
